import React from "react";

import { ArrowEnterLeftRegular } from "@fluentui/react-icons";
import {
  Card,
  Accordion,
  AccordionItem,
  AccordionHeader,
  Body2,
  AccordionPanel,
  Caption1,
  Body1Stronger,
  Body1,
  CardProps,
  mergeClasses,
} from "@fluentui/react-components";

import { Stack } from "../../../stack";
import { usePlaybookRuleCardStyles } from "./styles";

import { ClauseData } from "@/types/risk-analysis";

import { DEFAULT_CUSTOMER_RULE_ID } from "@/constants";

export interface PlaybookRuleCardProps extends CardProps {
  playbookRule: ClauseData;
}

export function PlaybookRuleCard({ playbookRule, className, ...props }: PlaybookRuleCardProps) {
  const styles = usePlaybookRuleCardStyles();

  const renderRule = (title: string, id: string, rule: string, example?: string) => {
    return (
      <Stack key={id} direction="column" gap="0.5rem">
        <Stack direction="column" gap="0.25rem">
          <Body1Stronger>{title}</Body1Stronger>
          <Body1 className={styles.ruleDescription}>{rule}</Body1>
        </Stack>
        <Stack direction="column" gap="0.25rem">
          <Stack align="center" gap="0.5rem">
            <ArrowEnterLeftRegular fontSize={12} className={styles.ruleIcon} />
            <Body1Stronger>Example Language</Body1Stronger>
          </Stack>
          <Body1 className={styles.ruleExample}>{example || "N/A"}</Body1>
        </Stack>
      </Stack>
    );
  };

  return (
    <Card className={mergeClasses(styles.card, className)} {...props}>
      <Accordion collapsible>
        <AccordionItem value={playbookRule.id}>
          <AccordionHeader button={{ className: styles.panelHeader }}>
            <Body2 className={styles.name}>{playbookRule.clauseTopic}</Body2>
          </AccordionHeader>
          <AccordionPanel>
            <Stack direction="column" gap="1rem" className={styles.panel}>
              <Caption1>Last updated on {new Date(playbookRule.updatedAt).toLocaleDateString()}</Caption1>
              {renderRule(
                "Rule Description",
                DEFAULT_CUSTOMER_RULE_ID,
                playbookRule.preferredLanguage,
                playbookRule.preferredLanguageExample
              )}
              {playbookRule.customerRules
                .filter((fallbackRule) => fallbackRule.id !== DEFAULT_CUSTOMER_RULE_ID)
                .map((fallbackRule, index) =>
                  renderRule(`Fallback ${index + 1}`, fallbackRule.id, fallbackRule.rule, fallbackRule.example)
                )}
            </Stack>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Card>
  );
}
